import { Component, OnInit, Input, HostListener } from '@angular/core';
import { Router } from "@angular/router";
import { AngularFireAuth } from "@angular/fire/auth";
import { Http } from "@angular/http"
import { take } from 'rxjs/operators';
import { MatSidenav } from '@angular/material/sidenav';
import { UsuarioService } from '../../../services/usuario.service';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';
import { VersaoNum } from "../../../versao";
import { AlertaVersaoComponentDialog } from '../../../modules/dialogs/versao-minima-dialog/versao-minima-dialog';
import { AlertaManutencaoDialog } from '../../../modules/dialogs/manutencao-dialog/manutencao-dialog';
import { ProdutoConsultaEstoqueMinimoElement } from 'src/app/interfaces/produtos.consulta';
import { ProdutoEstoqueConsulta } from 'src/app/interfaces/produtos.estoque';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() sidenav: MatSidenav
  uid;
  idCliente = environment.idCliente;

  contSolicitacoesCadastro: number = 0;
  contConfirmados: number = 0;
  contEmSeparacao: number = 0;
  contEmRota: number = 0;
  contValidacaoEstoque: number = 0;
  contQuantidadeMinimaEstoque: number = 0;
  contErroCadastroLatLng: number = 0;
  contSolicitacoesExclusaoDados: number = 0;
  contBoletosVencidos: number = 0;

  hiddenBadgeNovosPedidos = true;
  hiddenBadgeValidarEstoque = true;
  hiddenBadgeSolicitacoesCadastro = true;
  hiddenBadgeErroCadastroLatLng = true;


  innerWidth: any;
  @HostListener('window:resize', ['$event']) onResize(event) {

    this.innerWidth = event.target.innerWidth;
    console.log(event.target.innerHeight);
  }

  constructor(
    private af: AngularFireAuth,
    private router: Router,
    private http: Http,
    private usuarioService: UsuarioService,
    private dialog: MatDialog,

  ) {
    this.af.authState.subscribe((snap: any) => {
      this.uid = snap.uid;
    });
  }

  ngOnInit(): void {

    this.innerWidth = window.innerWidth;

    this.usuarioService.getStatusServidor().subscribe(snap => {
      let dados: any = snap.payload.val();

      if (!dados.Status) {
        const dialogRef2 = this.dialog.open(AlertaManutencaoDialog, {
          disableClose: true,
          data: { descricao: dados.Descricao, previsaoRetorno: this.usuarioService.tratarDataHora(dados.TimestampRetorno) },
        });

        dialogRef2.afterClosed().subscribe(result => {
        });

      } else
        if (VersaoNum < dados.VersaoMinima) {
          const dialogRef = this.dialog.open(AlertaVersaoComponentDialog, { disableClose: true });
          dialogRef.afterClosed().subscribe(result => {
          });
        }
    });


    this.http.get('https://jsonip.com').pipe(take(1)).subscribe(async resp => {
      localStorage.setItem("ip", resp.json().ip)
    });

    this.af.authState.subscribe((snap: any) => {
      this.uid = snap.uid;

      if (this.uid === environment.idCliente) {

        this.usuarioService.getSolicitacoesCadastrobVisualizada(this.uid).subscribe(snap => {

          let auxCont = 0;

          if (snap.length > 0) {
            var dados;

            snap.forEach((item, index) => {
              dados = item.payload.val();

              !dados.bVisualizada ? auxCont++ : null;
            });

            if (auxCont > 0) {
              this.contSolicitacoesCadastro = auxCont;
              this.hiddenBadgeSolicitacoesCadastro = false;
            } else {
              this.contSolicitacoesCadastro = 0;
              this.hiddenBadgeSolicitacoesCadastro = true;
            }
          }
        });

        //Contabiliza os confirmados
        this.usuarioService.getNovosPedidosStatus('Confirmado').subscribe(snap => {
          if (snap.length > 0) {
            this.contConfirmados = snap.length;
            this.hiddenBadgeNovosPedidos = false;
          } else {
            this.contConfirmados = 0;
            (this.contEmSeparacao === 0 && this.contEmRota === 0) ? this.hiddenBadgeNovosPedidos = true : null;
          }
        });

        //Contabiliza os Em separacao
        this.usuarioService.getNovosPedidosStatus('Em separação').subscribe(snap => {
          if (snap.length > 0) {
            this.contEmSeparacao = snap.length;
            this.hiddenBadgeNovosPedidos = false;
          } else {
            this.contEmSeparacao = 0;
            (this.contConfirmados === 0 && this.contEmRota === 0) ? this.hiddenBadgeNovosPedidos = true : null;
          }
        });

        //Contabiliza os Em rota
        this.usuarioService.getNovosPedidosStatus('Em rota').subscribe(snap => {
          if (snap.length > 0) {
            this.contEmRota = snap.length;
            this.hiddenBadgeNovosPedidos = false;
          } else {
            this.contEmRota = 0;
            (this.contConfirmados === 0 && this.contEmSeparacao === 0) ? this.hiddenBadgeNovosPedidos = true : null;
          }
        });

        //Removido para diminuir a debanda de processamento, fora o limite de 10000. Com isso, foi realizada a busca para StatusPedido.equalTo()
        // this.usuarioService.getNovosPedidosStatus(this.uid).subscribe(snap => {
        //   let auxCont = 0;

        //   if (snap.length > 0) {
        //     var dados;

        //     let aux;
        //     snap.forEach((item, index) => {
        //       dados = item.payload.val();
        //       aux = (dados.Status !== 'Entregue' && dados.Status !== 'Cancelado') ? auxCont++ : null;
        //     });

        //     if (auxCont > 0) {
        //       this.contNovosPedidos = auxCont;
        //       this.hiddenBadgeNovosPedidos = false;
        //     } else {
        //       this.contNovosPedidos = 0;
        //       this.hiddenBadgeNovosPedidos = true;
        //     }
        //   }
        // });
      }
    });

    this.usuarioService.setTimestamp().then(resp => {
      if (resp) {
        this.usuarioService.getTimestamp().pipe(take(1)).subscribe(snap => {

          if (snap) {
            let auxDate = new Date();
            auxDate.setTime(Number(snap.payload.val()) - 300000); //Substrai 5 minutos;
            //86400000 1 dia
            //Valida conferência estoque
            this.usuarioService.getConferenciaEstoque().subscribe(snap => {
              this.contValidacaoEstoque = 0;
              let auxCont = 0;

              if (snap.length > 0) {
                var dados;

                snap.forEach((item, index) => {
                  dados = item.payload.val();

                  if (!dados.Visualizado && dados.Timestamp <= auxDate.getTime()) {
                    auxCont++;
                  }
                });

                if (auxCont > 0) {
                  this.contValidacaoEstoque = auxCont;
                  this.hiddenBadgeValidarEstoque = false;
                } else {
                  this.contValidacaoEstoque = 0;
                  this.hiddenBadgeValidarEstoque = true;
                }
              }
            });
          }

        })
      }
    });

    //#region contabiliza alerta estoque mínimo de produtos
    this.usuarioService.getProdutos().pipe(take(1)).subscribe(async snap => {
      this.contQuantidadeMinimaEstoque = 0;
      const estoques = await this.usuarioService.getEstoquesProdutos();

      if (snap.length > 0) {
        var dados;
        let auxProdutosSource: ProdutoConsultaEstoqueMinimoElement[] = [];

        snap.forEach((item, index) => {
          dados = item.payload.val();
          if (dados.Status)
            auxProdutosSource.push({
              ID: item.key,
              QuantidadeMinimaAlertaEstoque: dados.QuantidadeMinimaAlertaEstoque
            });
        });

        this.usuarioService.getEstoqueProdutos().pipe(take(1)).subscribe(snap => {
          if (snap.length > 0) {
            let index: number;
            let dados: ProdutoEstoqueConsulta;
            let quantidadeEstoqueProduto: number | undefined;

            snap.forEach((item) => {
              dados = item.payload.val() as ProdutoEstoqueConsulta;
              quantidadeEstoqueProduto = estoques.find(e => e.ID === item.key)?.QuantidadeEstoque;
              if (quantidadeEstoqueProduto !== undefined) {
                index = auxProdutosSource.findIndex(p => p.ID == item.key);
                if (index !== -1)
                  if (auxProdutosSource[index].QuantidadeMinimaAlertaEstoque >= quantidadeEstoqueProduto)
                    this.contQuantidadeMinimaEstoque++;
              }
            });
          }
        });
      }
    });
    //#endregion

    this.usuarioService.getClientesFalseLatitude().subscribe(snap => {
      if (snap) {

        this.contErroCadastroLatLng = 0;
        let dados;
        snap.forEach((item, index) => {
          dados = item.payload.val();

          if (!dados.Latitude || !dados.Longitude) {
            this.contErroCadastroLatLng++;
          }
        });

        this.contErroCadastroLatLng !== 0 ? this.hiddenBadgeErroCadastroLatLng = false : this.hiddenBadgeErroCadastroLatLng = true;
      }
    });

    //Contabiliza solicitações de exclusão de dados
    this.usuarioService.getSolicitacoesExclusaoDados().subscribe((snap: any) => {
      if (snap) {
        this.contSolicitacoesExclusaoDados = 0;

        snap.forEach((item, index) => {
          this.contSolicitacoesExclusaoDados++;
        });
      }
    });

    this.usuarioService.getAllBoletosPendentes().subscribe((snap: any) => {
      if (snap) {
        this.contBoletosVencidos = 0;
        const dataAtual: Date = new Date();
        let auxDateVencimento: Date = new Date();
        let dados: any;

        snap.forEach((item, index) => {
          dados = item.payload.val();
          auxDateVencimento.setTime(dados.TimestampVencimento);

          if (auxDateVencimento < dataAtual)
            this.contBoletosVencidos++;
        });
      }
    });
  }

  signOut() {
    this.af.signOut().then(resp => {
      localStorage.setItem('login', 'true');
      localStorage.setItem('manter_conectado', 'false');
      this.router.navigate(["/login"]);
    });
  }

  navegarErroLatLng() {
    this.router.navigate(["/pages/erro-cadastro-lat-lng"]);
  }

  navegarSolicitacoes() {
    this.router.navigate(["/pages/solicitacoes-cadastro"]);
  }

  navegarAlertaEstoque() {
    this.router.navigate(["/pages/relatorio-estoque"]);
  }

  navegarValidarEstoque() {
    this.router.navigate(["/pages/validar-estoque"]);
  }

  navegarPedidos() {
    this.router.navigate(["/pages/consultar-pedidos"]);
  }

  navegarSolicitacoesExclusaoDados() {
    this.router.navigate(["/pages/solicitacoes-exclusao-dados"]);
  }

  navegarRelatorioBoletos() {
    this.router.navigate(["/pages/relatorio-boletos"], { queryParams: { filtrarBoletosVencidos: true } });
  }

  goToHome() {
    // this.router.navigate(["/pages/dashboard"]);
    this.router.navigate(["/pages/dashboard"]);
  }

}
